import checkout from "./form";

const {
  formField: {
    checkbox1,
    checkbox2,
    taxCalculationPeriod,
    kyKetDu,
    firstTime,
    supplementaryForThe,
    taxpayerName,
    taxId,
    contract,
    taxId2,
    checkbox3,
    checkbox4,
    taxId3,

    fullName,
    certificate,
    signer,
    timeSign,
  },
} = checkout;

const initialValues = {
  [fullName.name]: "",
  [certificate.name]: "",
  [kyKetDu.name]: "",
  [signer.name]: "",
  [timeSign.name]: "",
  [checkbox1.name]: false,
  [checkbox2.name]: false,
  [checkbox3.name]: false,
  [checkbox4.name]: false,
  [taxCalculationPeriod.name]: "",
  [firstTime.name]: false,
  [supplementaryForThe.name]: "",
  [taxpayerName.name]: "",
  [taxId.name]: "",
  [contract.name]: "",
  [taxId2.name]: "",
  [taxId3.name]: "",
};

export default initialValues;
